<template>

    <div class="w-2/3 p-6">

        <!--<h3>Drag Status: {{ draggingInfo }}</h3>-->

        <draggable class="list-group flex flex-col pb-6" v-model="modulesOrder" v-bind="dragOptions" :move="checkMove" @start="hasStartedDragging" @end="hasFinishedDragging">

            <transition-group type="transition">

                <display-block v-for="element in modulesOrder" :key="element.id" :title="element.id" :bodyText="element.title" :bodyTextEn="element.title_en" :is_active="element.is_active" :message="translate('config-show-home')"></display-block>

            </transition-group>

        </draggable>

        <!--<p class="text-base text-theme-main">{{ hasChanged }}</p>-->

        <button v-if="hasChanged" type="button" class="w-48 h-10 mt-4 bg-theme-controls3 hover:bg-theme-controls1 text-theme-control-label rounded-lg shadow" @click="storeChanges">{{ translate('save-changes') }}</button>
        <button v-if="hasChanged" type="button" class="w-48 h-10 mt-4 bg-theme-controls3 hover:bg-theme-controls1 text-theme-discrete hover:text-theme-control-label rounded-lg shadow" @click="cancelEdit">{{ translate('cancel') }}</button>

        <!--<br /><br />{{ modulesOrder }}-->

    </div>

</template>

<script>

    import draggable from "vuedraggable";
    import DisplayBlock from './DisplayBlock'

    const Lang = require('lang.js');
    import translations from './messages.js';

    const lang = new Lang();

    lang.setMessages(translations);

    let id = 1;

    export default {

        name: "draggable-block",
        display: "DraggableBLock",
        order: 0,
        components: {
            draggable,
            DisplayBlock
        },

        props: [

            'categories',
            'content_modules_order',
            'currentlocale'

        ],

        data() {
            return {

                enabled: true,

                /*list: [
                    { 'sectionId': '1', 'bodyText': 'Title for Section 1' },
                    { 'sectionId': '2', 'bodyText': 'Title for Section 2' },
                    { 'sectionId': '3', 'bodyText': 'Title for Section 3' },
                    { 'sectionId': '4', 'bodyText': 'Title for Section 4' }
                ],*/

                dragging: false,
                hasChanged: false,
                modulesOrder: JSON.parse(this.content_modules_order)

            };
        },

        computed: {
            draggingInfo() {

                return this.dragging ? "under drag" : "";

            },

            dragOptions() {

                return {
                    animation: 200,
                    group: "description",
                    disabled: false,
                    ghostClass: "moving-card",
                    handle: ".handle"
                };

            }
        },

        methods: {

            translate(key) {
                key = 'strings.' + key;
                return lang.get(key);
            },

            cancelEdit() {

                window.location = '/' + this.currentlocale + '/siteconfig/homeorder'

            },

            storeChanges() {

                axios.post('/' + this.currentlocale + '/siteconfig/homeorder/store', { 'modulesOrder': this.modulesOrder })
                    .then((response) => {
                        this.hasChanged = false
                        this.flashMessage.success({
                            title: '',
                            message: this.translate('config-stored'),
                            blockClass: 'p-6',
                            x: 25,
                            y: 150,
                            time: 3000
                        });
                    }).catch((error) => {
                        console.log('ERROR trying to store the configuration changes: ' + error)
                })

            },

            checkMove: function(e) {
                /*window.console.log("Future index: " + e.draggedContext.futureIndex);*/
            },

            sort() {
                this.list = this.list.sort((a, b) => a.order - b.order);
            },

            hasStartedDragging: function(e) {

                this.dragging = true

            },

            hasFinishedDragging: function(e) {

                this.dragging = false

                if(!(e.oldIndex === e.newIndex)) {
                    this.hasChanged = true
                }

            }
        },

        mounted() {

            console.log('DraggableSection component mounted.')

            Event.listen('toggleActiveSection', (data) => {

                // console.log('Triggered for: ' + JSON.stringify(data.id))
                this.hasChanged = true
                this.modulesOrder.find( ({id}) => id == data.id ).is_active = !this.modulesOrder.find( ({id}) => id == data.id ).is_active

            });

        },

        created() {

            /*let theCats = JSON.parse(this.categories)

            JSON.parse(this.content_modules_order).forEach((item) => {
                console.log(item)
                console.log(theCats.find( ({id}) => id == item ))
            })*/

        }

    }

</script>
